import { render, staticRenderFns } from "./InternalCorrectiveActionRequestForm.vue?vue&type=template&id=64456784"
import script from "./InternalCorrectiveActionRequestForm.vue?vue&type=script&lang=js"
export * from "./InternalCorrectiveActionRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports